import { Controller } from "@hotwired/stimulus"
import { money, number, percent, read } from "../../lib/format"

// Price per share and ownership after a priced round.
export default class extends Controller {
  static targets = ["shares", "premoney", "investment", "postmoney", "pps", "newshares", "existing", "investor"]
  static values = { messages: Object }

  connect() { this.compute() }

  compute() {
    const shares = read(this.sharesTarget)
    const premoney = read(this.premoneyTarget)
    const investment = read(this.investmentTarget)
    const postmoney = premoney + investment
    const pps = shares > 0 ? premoney / shares : NaN
    const issued = pps > 0 ? investment / pps : NaN
    const total = shares + issued

    this.postmoneyTarget.textContent = money(postmoney)
    this.ppsTarget.textContent = money(pps, 2)
    this.newsharesTarget.textContent = number(issued)
    this.existingTarget.innerHTML = `${percent(total > 0 ? shares / total : NaN)} <small>${this.messagesValue.from_full}</small>`
    this.investorTarget.textContent = percent(postmoney > 0 ? investment / postmoney : NaN)
  }
}
